// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReasonReact = require("reason-react/src/ReasonReact.js");
var Menu$ReasonProfile = require("./components/common/menu/Menu.bs.js");
var Profile$ReasonProfile = require("./components/profile/Profile.bs.js");

var component = ReasonReact.statelessComponent("App");

function make(_children) {
  return {
          debugName: component.debugName,
          reactClassInternal: component.reactClassInternal,
          handedOffState: component.handedOffState,
          willReceiveProps: component.willReceiveProps,
          didMount: component.didMount,
          didUpdate: component.didUpdate,
          willUnmount: component.willUnmount,
          willUpdate: component.willUpdate,
          shouldUpdate: component.shouldUpdate,
          render: (function (_self) {
              return React.createElement("div", undefined, ReasonReact.element(undefined, undefined, Menu$ReasonProfile.make(/* array */[])), ReasonReact.element(undefined, undefined, Profile$ReasonProfile.make(/* array */[])));
            }),
          initialState: component.initialState,
          retainedProps: component.retainedProps,
          reducer: component.reducer,
          jsElementWrapped: component.jsElementWrapped
        };
}

exports.component = component;
exports.make = make;
/* component Not a pure module */
